<template>
  <div class="header">
    <div class="nav" :style="{height:isPositionTop ? '0' :'18vw'}">
      <img src="https://summit-img.geekpark.net/mobile/header-nav-image.svg" style="width: 50vw">
      <img src="https://summit-img.geekpark.net/mobile/01-%E5%AF%BC%E8%88%AA-%E5%85%B3%E9%97%AD.svg" style="width: 8vw"
           v-show="!hideNavs" @click="toggleNavsVisible">
      <img src="https://summit-img.geekpark.net/mobile/01-%E5%AF%BC%E8%88%AA-%E8%8F%9C%E5%8D%95.svg" style="width: 8vw"
           v-show="hideNavs" @click="toggleNavsVisible">
      <ul class="navs" v-show="!hideNavs">
        <li v-for="(item,index) in navs" :key="index">
          <a href="" @click.prevent="scrollToPosition(item.position)">
            <img :src="item.name" :style="item.style">
          </a>
        </li>
      </ul>
    </div>
    <img src="https://summit-img.geekpark.net/IFX-10th%20logo.svg"
         style="width: 90vw; margin: 5vw 0vw 10vw 0vw;visibility: hidden" v-show="!isPositionTop">
    <img src="https://summit-img.geekpark.net/IFX-10th%20logo.svg" style="width: 90vw; margin: 5vw 0vw 10vw 0vw;"
         v-show="isPositionTop">
    <img src="https://summit-img.geekpark.net/mobile/IFX.svg" style="width: 90vw">
    <img src="https://summit-img.geekpark.net/mobile/%E6%97%B6%E9%97%B4%E5%9C%B0%E7%82%B9-m.svg"
         style="position:absolute;width:19vw;top:48vw;right: 5vw;">
    <img src="https://summit-img.geekpark.net/mobile/for-the-next.svg"
         style="position:absolute;width: 70vw;left: 14vw;top: 48vw;">
    <router-link to="/live">
      <img src="https://summit-img.geekpark.net/ifx/pc/%E7%B2%BE%E5%BD%A9%E5%9B%BE%E7%89%87.svg" alt="" style="width: 30vw;position: absolute;right: 0; top: 95vw;">
    </router-link>
  </div>
</template>

<script>

export default {
  name: 'Header',
  data () {
    return {
      isPositionTop: true,
      hideNavs: true,
      navs: [
        {
          name: 'https://summit-img.geekpark.net/mobile/v2-%E5%AF%BC%E8%88%AA-mobile-%E4%B8%BB%E8%AE%BA%E5%9D%9B.svg',
          style: 'width:15vw',
          position: '#schedule'
        },
        {
          name: 'https://summit-img.geekpark.net/mobile/v2-%E5%AF%BC%E8%88%AA-mobile-%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B.svg',
          style: 'width:20vw',
          position: '#forum'
        },
        {
          name: 'https://summit-img.geekpark.net/mobile/%E7%89%B9%E5%88%AB%E5%B1%95-mobile.svg',
          style: 'width:15vw',
          position: '#museum'
        },
        {
          name: 'https://summit-img.geekpark.net/mobile/%E5%B9%B4%E5%BA%A6%E7%9B%98%E7%82%B9-mobile.svg',
          style: 'width:20vw',
          position: '#stoke-take'
        },
        {
          name: 'https://summit-img.geekpark.net/mobile/%E9%82%AE%E4%BB%B6%E8%AE%A2%E9%98%85-mobile.svg',
          style: 'width:20vw',
          position: '#subscribe'
        },
        {
          name: 'https://summit-img.geekpark.net/mobile/%E8%B4%AD%E7%A5%A8-mobile.svg',
          style: 'width:12vw',
          position: '#lock-ticket'
        },
        {
          name: 'https://summit-img.geekpark.net/mobile/%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC-mobile.svg',
          style: 'width:20vw',
          position: '#footer'
        }
        // {
        //   name: 'https://summit-img.geekpark.net/mobile/IFX-%E6%B5%B7%E5%A4%96%E7%AB%99-m.svg',
        //   style: 'width:15vw',
        //   position: 'http://global.geekpark.net/'
        // }
      ]
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleNavState)
  },
  methods: {
    getElementTop (element) {
      let actualTop = element.offsetTop
      let current = element.offsetParent

      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }

      return actualTop
    },
    handleNavState (e) {
      this.hideNavs = true
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollHeight > 0) {
        this.isPositionTop = false
      } else {
        this.isPositionTop = true
      }
    },
    toggleNavsVisible () {
      this.hideNavs = !this.hideNavs
    },
    scrollToPosition (id) {
      if (id.startsWith('#')) {
        const navsHeight = document.querySelector('.nav').offsetHeight
        const position = this.getElementTop(document.querySelector(id))
        window.scrollTo({
          top: position - navsHeight,
          behavior: 'smooth'
        })
      } else {
        window.open(id, 'blank')
      }
      return false
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleNavState)
  }
}
</script>

<style scoped lang="less">
  .header {
    position: relative;
    padding-bottom: 45vw;
  }

  .nav {
    box-sizing: border-box;
    position: fixed;
    width: 100vw;
    left: 0;
    top: 0;
    padding: 0 5vw;
    display: flex;
    justify-content: space-between;
    background: #2b2b2b;
    text-align: left;
    z-index: 100;
    transition: height .3s;
  }

  ul.navs {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    padding: 7vw 0;
    box-shadow: 0 15px 30px rgba(0, 0, 0, .1);
    background-color: #fff;
    transition: opacity .3s linear;

    li {
      height: 12vw;
      list-style: none;

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        color: #1d1d1d;
        text-decoration: none;
        text-align: center;
        letter-spacing: 0.5vw;
        font-size: 4.2vw;
      }
    }
  }
</style>
